module.exports = __webpack_public_path__ + "static/media/1.a5d5a5c6.svg";